import * as React from 'react'

import { useModalManager } from '~/hooks'
import { storage } from '~/utils'

import { REPURCHASE_DIALOG_CHECKBOX_ID, RepurchaseDialog } from '../dialog'

export function useRepurchaseConfirmation<TArgs extends any[]>(
  onAction: (...args: TArgs) => void | Promise<void>,
): (...args: TArgs) => Promise<void> {
  const modalManager = useModalManager()

  return React.useCallback(
    async (...args: TArgs): Promise<void> => {
      const cannotShowConfirmDialog = storage.get(REPURCHASE_DIALOG_CHECKBOX_ID)

      if (cannotShowConfirmDialog) {
        await onAction(...args)
      } else {
        modalManager.openModal(RepurchaseDialog, {
          onClose: () => {
            modalManager.closeModal()
          },
          onAccept: async () => {
            await onAction(...args)

            modalManager.closeModal()
          },
        })
      }
    },
    [onAction, modalManager],
  )
}
